export const routes = Object.freeze({
  base: '/',
  home: '/home',
  account: '/home/account/:walletId',
  xero: '/home/xero',
  managePayment: '/home/manage/payment',
  teamMembers: '/home/manage/team',
  cards: '/home/manage/cards',
  generalLedgerSettings: '/home/settings/general-ledger-settings',
  passkeySettings: '/home/settings/passkeys',
  transferMoney: '/home/transfer',
  selectedAccount: '/home/account/:walletId',
  payment: '/home/payment',
  newBatchPayment: '/home/batch/payment/new'
});
